import { render } from "./ResetPass2.vue?vue&type=template&id=15d374f8&scoped=true"
import script from "./ResetPass2.vue?vue&type=script&lang=js"
export * from "./ResetPass2.vue?vue&type=script&lang=js"

import "./ResetPass2.vue?vue&type=style&index=0&id=15d374f8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d374f8"]])

export default __exports__